import { Injectable } from "@angular/core";

import { first } from "rxjs/operators";

import { SessionStorage } from "@dffedb/util";
import { InstallationMaalerAflaesning, InstallationMaalerAflaesningKvitteringService } from "@e-forsyning/common/maaler";
import { DffMailInternal, EforsyningMailBuilderService, EforsyningMailSenderService } from "@e-forsyning/common/mail";
import { UmbracoIndstillingerObserver } from "@e-forsyning/common/umbraco-indstillinger";

@Injectable({ providedIn: "root" })
export class FeatureMaalerAflaesningMailService {
    private subject = "Kvittering for din måleraflæsning";

    constructor(
        private readonly kvitteringService: InstallationMaalerAflaesningKvitteringService,
        private readonly eforsyningMailBuilder: EforsyningMailBuilderService,
        private readonly mailSender: EforsyningMailSenderService,
        private readonly umbracoIndstillingerObserver: UmbracoIndstillingerObserver,
        private readonly sessionStorage: SessionStorage
    ) {}

    public async sendMail(model: InstallationMaalerAflaesning, email: string): Promise<void> {
        const mail$ = await this.genererMail(model, email);
        return this.mailSender.sendMailFraUmbraco("SendMaaleraflaesningKviteringsMail", mail$);
    }

    private async genererMail(model: InstallationMaalerAflaesning, email: string): Promise<DffMailInternal> {
        const tmpModel = await this.kvitteringService.genererKvittering(model).pipe(first()).toPromise();
        const mailData = JSON.stringify(tmpModel);
        const result: DffMailInternal = {
            sideId: "",
            to: email,

            model: mailData
        };
        return result;
    }
}
